/**
 * H5 <-> Flutter 通信桥
 * 兼容 Android / iOS / Flutter / 调试环境
 */

type BridgeParams = Record<string, any>
type AppCallback = (data: any) => void

class Bridge {
  private callbacks: Record<string, AppCallback> = {}

  /**
   * ✅ H5 调用 Flutter / App
   * @param method 方法名（Flutter端对应的 handler 名）
   * @param params 参数对象
   */
  callApp(method: string, params: BridgeParams = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        // ✅ Flutter 环境（推荐）
        if (window.flutter_inappwebview) {
          window.flutter_inappwebview.callHandler(method, params).then(resolve).catch(reject)
        }
        // ✅ Android WebView 环境
        else if (window.Android && typeof window.Android[method] === 'function') {
          const result = window.Android[method](JSON.stringify(params))
          try {
            resolve(JSON.parse(result))
          } catch {
            resolve(result)
          }
        }
        // ✅ 调试环境（浏览器直接运行）
        else {
          console.log('📱 [Bridge 调试模式]:', { method, params })
          resolve({ debug: true, method, params })
        }
      } catch (err) {
        console.error('❌ [Bridge 调用失败]:', err)
        reject(err)
      }
    })
  }

  /**
   * ✅ 注册 Flutter 调 H5 的事件
   * Flutter 调用：controller.evaluateJavascript("window.Bridge.emit('事件名', JSON.stringify(data))")
   */
  on(name: string, callback: AppCallback) {
    this.callbacks[name] = callback
  }

  emit(name: string, data: any) {
    const cb = this.callbacks[name]
    if (cb) {
      cb(data)
    } else {
      console.warn(`⚠️ 未找到事件回调: ${name}`)
    }
  }
}

const bridge = new Bridge()

// 暴露给全局
;(window as any).Bridge = bridge

export default bridge
